/* unplugin-vue-components disabled */import { unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "loading-container"
};
import useUserStore from "@/store/modules/user";
import Cookies from "js-cookie";
export default {
  __name: 'index',
  setup(__props) {
    const showMask = ref(true);
    const chat = ref(null);
    let timer = undefined;
    let timer1 = undefined;
    const userStore = useUserStore();
    const postMessagrChat = () => {
      console.log(userStore.name);
      console.log(userStore);
      console.log("我发送了消息");
      console.log(chat);
      const winIframe = chat.value.contentWindow;
      console.log(winIframe);
      winIframe.postMessage({
        "oneMsg": userStore.name,
        "twoMsg": userStore.userSynapse
      }, '*');
    };
    onMounted(() => {
      console.log(Cookies);
      console.log("语音页面已经打开");
      console.log("语音页面已经打开");
      timer = setInterval(postMessagrChat, 1000);
      setTimeout(() => {
        clearInterval(timer);
      }, 50000); // 1.5分钟 = 90000毫秒

      timer1 = setTimeout(() => {
        showMask.value = false;
      }, 8000); // 8秒（30000毫秒）后消失
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_withDirectives(_createElementVNode("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [_createElementVNode("div", {
        class: "loading-message"
      }, " 语音系统正在加载中请稍后...... ", -1)]))], 512), [[_vShow, _unref(showMask)]]), _createElementVNode("div", null, [_createElementVNode("iframe", {
        ref_key: "chat",
        ref: chat,
        id: "iframe",
        width: "100%",
        height: "700px",
        src: "https://satwide.com/xzyy/#/login",
        allow: "camera *; microphone *"
      }, null, 512)])]);
    };
  }
};